import './array-polyfills';
import './class-list-polyfills';
import './custom-event-polyfill';
import './element-polyfills';
import './object-polyfills';
import './string-polyfills';
import 'es6-promise/dist/es6-promise.auto.js';

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
if (!Math.sign) {
  Math.sign = function (x) {
    return ((x > 0) - (x < 0)) || +x;
  };
}

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Math/trunc
if (!Math.trunc) {
  Math.trunc = function(v) {
    v = +v;
    return (v - v % 1)   ||   (!isFinite(v) || v === 0 ? v : v < 0 ? -0 : 0);
  };
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
if (!Number.isInteger) {
  Number.isInteger = function (value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN
if (!Number.isNaN) {
  Number.isNaN = function (value) {
    return value !== value;
  };
}
